import { Component, Input } from '@angular/core';

@Component({
  selector: 'om-hint',
  templateUrl: './om-hint.component.html',
  styleUrls: ['./om-hint.component.scss']
})
export class OmHintComponent {

  @Input() text: string;
  @Input() icon: string;

  constructor() { }
}
